import { Form } from "antd";
import styled from "styled-components";
import { theme } from "../../../theme";

/**
 * 폼 디자인로직 수정
 * - error일때만 help explain 가시화
 */
const CustomForm = styled(Form)`
  &.ant-form {
    & .ant-row {
      margin-bottom: 0;

      & .ant-col {
        justify-content: center;
        position: relative;

        &.ant-form-item-label {
          & label {
            font-weight: 700;
          }
        }

        & .ant-form-item-required {
          &::before {
            // '*' 오른쪽으로 옮김
            content: "";
            margin-right: 0;
          }
          &::after {
            display: inline-block;
            margin-left: 4px;
            color: ${({ theme }) => theme.color.red3};
            font-size: 15px;
            font-weight: 700;
            line-height: 1;
            content: "*";
          }
        }

        & .ant-form-item {
          margin-bottom: 0;
        }

        & .ant-form-item-explain {
          height: 0;

          .ant-row.ant-form-item-has-error & {
            height: auto;
            position: absolute;
          }
        }
      }
    }
  }
`;

const FormLabel = styled.div`
  display: inline-flex;
  ${theme.typo.heading.b14};
  color: ${theme.colors.gray1};
`;

const FormExtra = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${theme.typo.body.r14};
  color: ${theme.colors.gray1};
`;

export { CustomForm, FormExtra, FormLabel };
